import type { DiscoverNoteSource } from "../shared/source-contract";

/** A plain link to a web page brief evidence cites: site name, then title. */
export function RssNoteSourceCard({ note }: { note: DiscoverNoteSource }) {
  if (!note.url) {
    return null;
  }

  return (
    <div className="space-y-2">
      <p className="text-[0.85rem] text-[var(--explore-text-secondary)]">
        {new URL(note.url).hostname.replace(/^www\./, "")}
      </p>
      <a
        className="text-[0.85rem] text-[var(--explore-accent-teal)] underline underline-offset-4"
        href={note.url}
        rel="noreferrer noopener"
        target="_blank"
      >
        {note.title ?? "Open original page"}
      </a>
    </div>
  );
}
